export { ObservabilityProvider } from './ObservabilityProvider'
export { useObservability } from './useObservability'
// Call from the app's `instrumentation-client.ts`, which runs before React hydrates.
export { initializeObservability } from './adapters/faro'
// Non-hook accessor, for reporting from module scope where the React context is unavailable.
export { createFaroLogMethods } from './adapters/faro'
export { LogLevel } from '../types'
export type { ObservabilityClientConfig, ObservabilityMethods, LogContext, TransportItem } from '../types'
